// LegalText.js

export const termsOfServiceText = {
  title: "Terms of Service",
  sections: [
    {
      title: "1. Acceptance of Terms",
      content: "By accessing or using Puzzlify, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use the service."
    },
    {
      title: "2. Description of Service",
      content: "Puzzlify provides a platform for users to generate chess puzzles based on their own games from Lichess. We offer both free and paid services."
    },
    {
      title: "3. User Accounts",
      content: "You are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account."
    },
    {
      title: "4. Privacy Policy",
      content: "Our privacy practices are outlined in our Privacy Policy, which is incorporated into these Terms of Service."
    },
    {
      title: "5. Payment Terms",
      content: "If you choose to pay for unlimited puzzles, you agree to pay all fees in accordance with the pricing and payment terms in effect at that time."
    },
    {
      title: "6. Intellectual Property",
      content: "All content and materials available on Puzzlify are protected by intellectual property rights."
    },
    {
      title: "7. Limitation of Liability",
      content: "Puzzlify shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use the service."
    },
    {
      title: "8. Governing Law",
      content: "These Terms shall be governed by and construed in accordance with the laws of the jurisdiction in which the company operates."
    },
    {
      title: "9. Changes to Terms",
      content: "We reserve the right to modify these Terms at any time. Your continued use of Puzzlify after such changes constitutes your acceptance of the new Terms."
    }
  ]
};

export const privacyPolicyText = {
  title: "Privacy Policy",
  sections: [
    {
      title: "1. Introduction",
      content: "At Puzzlify, we take your privacy seriously. This Privacy Policy explains how we collect, use, and protect your personal data."
    },
    {
      title: "2. Information We Collect",
      content: "We collect the following types of information:",
      list: [
        { text: "Google Sign-In Data: If you choose to sign in with Google, we collect your email address and name as provided by Google." },
        { text: "Lichess Username: We collect the Lichess username you provide to generate chess puzzles from your games." },
        { text: "Usage Data: Information about how you interact with our service, such as the puzzles you generate and solve." }
      ]
    },
    {
      title: "3. How We Use Your Information",
      content: "We use your personal information for the following purposes:",
      list: [
        { text: "To provide and maintain our service" },
        { text: "To generate custom chess puzzles based on your Lichess games" },
        { text: "To identify you and maintain your account" },
        { text: "To improve our service and user experience" },
        { text: "To communicate with you regarding your account or our service" }
      ]
    },
    {
      title: "4. Data Storage and Security",
      content: "We implement appropriate security measures to protect your personal information. Your data is stored securely and is only accessible to authorized personnel."
    },
    {
      title: "5. Third-Party Services",
      content: "We use the following third-party services:",
      list: [
        { text: "Google Authentication: For user authentication" },
        { text: "Lichess API: To access your public chess games" },
        { text: "Stripe: For payment processing (if applicable)" }
      ]
    },
    {
      title: "6. Your Rights",
      content: "You have the right to:",
      list: [
        { text: "Access your personal data" },
        { text: "Request correction of inaccurate data" },
        { text: "Request deletion of your data" },
        { text: "Withdraw consent at any time" }
      ]
    },
    {
      title: "7. Changes to This Privacy Policy",
      content: "We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page."
    },
    {
      title: "8. Contact Us",
      content: "If you have any questions about this Privacy Policy, please contact us at puzzlify@puzzlify.io"
    }
  ]
}; 